import gql from 'graphql-tag';

export default gql`
mutation ($id: String!, $name: String!, $status: ReportStatus!, $version: Int!, $file: S3ObjectInput!) {
    updateReport (input:  {
        id: $id
        name: $name
        status: $status
        version: $version,
        file: $file
    }) {
        __typename
        id
        name
        status
        pages{            
          index
          name
          displayName
          default
          visible
        }
        reportTypeId
        menuLabel
        menuOrder
        powerBiDataset
        powerBiEmbedUrl
        powerBiReport
        accessToken      
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Reports/UpdateFileMutation.js